module.exports = __webpack_public_path__ + "static/media/lakers_featured_player.2c79619b.png";